module.exports = __webpack_public_path__ + "img/wtjj.dbb123a2.png";